import MeetingRoomNoticeTable from "../Modal/Notice/MeetingRoomNoticeTable";
import MeetingRoomNoticeEdit from "../Modal/Notice/MeetingRoomNoticeEdit";
import MeetingRoomNoticeDetail from "../Modal/Notice/MeetingRoomNoticeDetail";

import { Box, Modal } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { ModalState, NOTICE_SERVICE_TYPE } from "../../../system/Constants";
import { NoticeData } from "../../../system/types/Notice";
import { InitNoticeDetailData } from "../../../system/types/initObject";
import { NoticeApi } from "../../../system/api/NoticeApi";
import { ErrorHandler } from "../../../system/ApiService";
import AlertModal from "../../Common/AlertModal";
import {
  MeetingRoomNoticeBox,
  MeetingRoomNoticeIcon,
  MeetingRoomRightBoxSideColor,
  MeetingRoomRightBoxTitle,
  NoticeTitleBox,
  NoticeTitleSpanBox,
  NoticeTitleWrapper,
} from "./MeetingRoomNoticeStyled";
import { ModalStyle } from "../../../styles/theme";

function MeetingRoomNoticeBar() {
  const [modalOpen, setModalOpen] = useState(false);
  // state 분류 - table, edit, detail
  const [noticeState, setNoticeState] = useState(ModalState.table);

  // 메인 공지 사항 정보
  const [mainNoticeData, setMainNoticeData] =
    useState<NoticeData>(InitNoticeDetailData);

  // 선택한 공지 사항 정보
  const [selectedNotice, setSelectedNotice] =
    useState<NoticeData>(InitNoticeDetailData);

  // 공지 사항 목록
  const [noticeData, setNoticeData] = useState<NoticeData[]>([]);

  // 페이지 번호
  const [pageNumber, setPageNumber] = useState<number>(0);

  // 총 페이지 수
  const [totalPage, setTotalPage] = useState(1);

  const handleClose = () => {
    setModalOpen(false);
    setNoticeState(ModalState.table);
  };

  // 공지사항 조회
  const getNoticeData = useCallback(() => {
    NoticeApi.getNoticeData(NOTICE_SERVICE_TYPE.MEETING_ROOM, pageNumber, 10)
      .then((res) => {
        setNoticeData(res.data.notice);
        setTotalPage(res.data.totalPages);
      })
      .catch((err) => {
        let msg = ErrorHandler(err);
        AlertModal("msg", msg);
      });
  }, [pageNumber]);

  // 메인 공지사항 조회
  const getMainNotice = useCallback(() => {
    const ComparedTodayDate = new Date();
    NoticeApi.getNoticeData(NOTICE_SERVICE_TYPE.MEETING_ROOM, 0, 1)
      .then((res) => {
        if (
          res.data.notice.length > 0 &&
          res.data.notice[0].mainStartDate &&
          new Date(res.data.notice[0].mainStartDate) < ComparedTodayDate &&
          (res.data.notice[0].mainEndDate === null ||
            new Date(res.data.notice[0].mainEndDate) > ComparedTodayDate)
        ) {
          setMainNoticeData(res.data.notice[0]);
        }
      })
      .catch((err) => {
        let msg = ErrorHandler(err);
        AlertModal("msg", msg);
      });
  }, []);

  const openMainNoticeModal = useCallback(() => {
    setModalOpen(true);
    setNoticeState(ModalState.detail);
    setSelectedNotice(mainNoticeData);
  }, [mainNoticeData]);

  useEffect(() => {
    getMainNotice();
  }, []);

  useEffect(() => {
    getNoticeData();
  }, [getNoticeData]);

  return (
    <MeetingRoomNoticeBox>
      <NoticeTitleWrapper>
        <MeetingRoomRightBoxTitle>공지사항</MeetingRoomRightBoxTitle>

        {mainNoticeData.title === "" ? (
          "등록된 주요 공지사항이 없습니다."
        ) : (
          <NoticeTitleBox onClick={openMainNoticeModal}>
            <MeetingRoomNoticeIcon
              src="/images/VEHICLE/mainSpeaker.png"
              alt="주요 공지사항"
            />
            <NoticeTitleSpanBox>{mainNoticeData.title}</NoticeTitleSpanBox>
          </NoticeTitleBox>
        )}
      </NoticeTitleWrapper>

      <MeetingRoomRightBoxSideColor
        onClick={() => {
          setModalOpen(true);
          setPageNumber(0);
        }}
      >
        전체보기
      </MeetingRoomRightBoxSideColor>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyle}>
          {noticeState === ModalState.table && (
            <MeetingRoomNoticeTable
              setSelectedNotice={setSelectedNotice}
              setNoticeState={setNoticeState}
              handleClose={handleClose}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              noticeData={noticeData}
              totalPage={totalPage}
            />
          )}
          {noticeState === ModalState.edit && (
            <MeetingRoomNoticeEdit
              handleClose={handleClose}
              selectedNotice={selectedNotice}
              setNoticeState={setNoticeState}
              getNoticeData={getNoticeData}
              setPageNumber={setPageNumber}
            />
          )}
          {noticeState === ModalState.detail && (
            <MeetingRoomNoticeDetail
              handleClose={handleClose}
              selectedNotice={selectedNotice}
              setNoticeState={setNoticeState}
            />
          )}
        </Box>
      </Modal>
    </MeetingRoomNoticeBox>
  );
}

export default MeetingRoomNoticeBar;
